/**
 * While the device performance test runs it needs the GPU to itself: the
 * garage turntable and a mounted race skip their frames (and keep their
 * loops alive) until it releases the flag.
 */
let holders = 0;

export function acquireGpuExclusive(): () => void {
  holders += 1;
  let released = false;
  return () => {
    if (released) return;
    released = true;
    holders = Math.max(0, holders - 1);
  };
}

export function gpuExclusiveActive(): boolean {
  return holders > 0;
}
